module.exports = __webpack_public_path__ + "assets/img/examNow.79bb9369.png";